<div class="placement-history-container">
    <div class="loading-container" *ngIf="loadSpinner" role="status" aria-live="polite">
        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
    </div>
    <kendo-grid [data]="placementData" [kendoGridBinding]="placementData" [pageable]="true" [pageSize]="5">
    <kendo-grid-column field="status" [headerClass]="'grid-header'" title="Status"
        [autoSize]="columnDefinitions[0]?.autoSize" [width]="columnDefinitions[0]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            <span [class.rescinded-status]="isRescindedPlacement(row)">{{getPlacementStatus(row)}}</span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="schoolName" title="School"
        [autoSize]="columnDefinitions[1]?.autoSize" [width]="columnDefinitions[1]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            {{row?.schoolName}}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="schoolDBN" title="Admin DBN" [autoSize]="columnDefinitions[2]?.autoSize"
        [width]="columnDefinitions[2]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            {{row?.schoolDBN}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="buildingCode" title="Physical Location" [autoSize]="columnDefinitions[3]?.autoSize"
        [width]="columnDefinitions[3]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            {{row?.buildingCode}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="program" title="Program" [autoSize]="columnDefinitions[4]?.autoSize"
        [width]="columnDefinitions[4]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            {{row?.className}}

        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="specializedProgramName" title="Instruction Model" [autoSize]="columnDefinitions[4]?.autoSize"
        [width]="columnDefinitions[4]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            {{row?.specializedProgramName}}

        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="placementType" title="Placement Type" [autoSize]="columnDefinitions[5]?.autoSize"
        [width]="columnDefinitions[5]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            {{row?.placementType}}

        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="placementDate" title="Placement Date" [autoSize]="columnDefinitions[6]?.autoSize"
        [width]="columnDefinitions[6]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            {{ row?.placementDate ? (row?.placementDate | date: 'MM/dd/yyyy hh:mm a') : '' }}

        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="schoolYear" title="School Year" [autoSize]="columnDefinitions[7]?.autoSize"
        [width]="columnDefinitions[7]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            {{row?.schoolYear}}

        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="rescindReason" title="Rescind Reason (if applicable)" [autoSize]="columnDefinitions[8]?.autoSize"
        [width]="columnDefinitions[8]?.width">
        <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
            {{getRescindReason(row)}}
        </ng-template>
    </kendo-grid-column>


    <ng-template kendoGridNoRecordsTemplate>
        <div>
            <kendo-badge-container>
                <kendo-svg-icon [icon]="cloudIcon" size="large"></kendo-svg-icon>
                <kendo-badge position="inside" themeColor="error">
                    <kendo-svg-icon [icon]="xIcon"></kendo-svg-icon>
                </kendo-badge>
            </kendo-badge-container>
        </div>
        <div class="k-pt-2">There is no data to display.</div> <!-- TODO use the css library for styles -->
    </ng-template>
</kendo-grid>
</div>